
import { lazy, Suspense } from 'react';
import Hero from '@/components/Hero';
import SEO from '@/components/SEO';
import Features from '@/components/Features';

// Lazy load WhyHouseBeat - it's below the fold and uses framer-motion
const WhyHouseBeat = lazy(() => import('@/components/WhyHouseBeat'));

const Index = () => {
  return (
    <>
      <SEO
        title="Home management app for predictable maintenance | House Beat" 
        description="The home management app that helps homeowners avoid surprises and reduce financial risk with personalized maintenance plans and monthly guidance."
        imageUrl="/SocialShareImage.png"
        keywords={['home management app', 'home maintenance', 'predictable maintenance', 'homeownership', 'property maintenance', 'home budget', 'maintenance tracker', 'home care']}
      />
      <Hero />
      <Features />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <WhyHouseBeat />
      </Suspense>
    </>
  );
};

export default Index;
